'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_annotation_Annotation() {
}
export { $c_s_annotation_Annotation as $c_s_annotation_Annotation };
$p = $c_s_annotation_Annotation.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_annotation_Annotation;
/** @constructor */
function $h_s_annotation_Annotation() {
}
export { $h_s_annotation_Annotation as $h_s_annotation_Annotation };
$h_s_annotation_Annotation.prototype = $p;
